import { render, staticRenderFns } from "./Control.vue?vue&type=template&id=ff84fae0&scoped=true&"
import script from "./Control.vue?vue&type=script&lang=js&"
export * from "./Control.vue?vue&type=script&lang=js&"
import style0 from "./Control.vue?vue&type=style&index=0&id=ff84fae0&prod&lang=scss&scoped=true&"
import style1 from "./Control.vue?vue&type=style&index=1&id=ff84fae0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff84fae0",
  null
  
)

export default component.exports